export const PAGE_SIZE = 20;

export const columns = [
    {
        Header: 'Address',
        accessor: 'Address',
    },
    {
        Header: 'Site Name',
        accessor: 'Name',
    },
    {
        Header: 'Company',
        accessor: 'CompanyName',
    },
    {
        Header: 'Installer',
        accessor: 'InstallerName',
    },
    {
        Header: 'Install Date',
        accessor: 'createdAt',
        component: (value) =>
            new Date(value.createdAt).toLocaleDateString('en-US', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
            }),
    },
    // Optional columns for admin/installer roles
    {
        Header: 'Customer Name',
        accessor: 'CustomerName',
    },
    {
        Header: 'Customer Email',
        accessor: 'CustomerEmail',
    },
];
